import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';

import { InfoModalStyled } from './styled';

const DynamicPropertiesInfoModal = ({ visible, propertyData, onCancel }) => {
  const data = propertyData || {};

  return (
    <InfoModalStyled
      className="dynamic-properties-info-modal"
      title={data.propertyEnglishName}
      showCheckIcon={false}
      width="500px"
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Row gutter={32}>
        <Col span={10} className="basic-info-container">
          <div className="basic-info-content">
            <h4>Basic Info</h4>
            <p>{data.shortInfo}</p>
          </div>
          <div className="description-content">
            <h4>Description</h4>
            <p>{data.propertyDesc}</p>
          </div>
        </Col>
        <Col span={14} className="format-container">
          <div className="format-content">
            <h4>Format</h4>
            <p>{data.format}</p>
          </div>
        </Col>
      </Row>
    </InfoModalStyled>
  );
};

DynamicPropertiesInfoModal.propTypes = {
  visible: PropTypes.bool,
  propertyData: PropTypes.object,
  onCancel: PropTypes.func
};

export default DynamicPropertiesInfoModal;
